import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistSectionDocumentDeleteModel } from 'shared/domain/checklistSection/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistSectionDocumentHttpDeleteRequestModel } from '../httpQueue/checklistSection/types';

export class ChecklistSectionDocumentDeleter {
  constructor(
    private addRequest: (
      request: ChecklistSectionDocumentHttpDeleteRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    deleteModel: ChecklistSectionDocumentDeleteModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('DeleteChecklistSectionDocumentUseCase', deleteModel);

    const url = `/project/${deleteModel.projectId}/inspectionTemplate/${deleteModel.inspectionTemplateId}/section/${deleteModel.sectionId}/document/${deleteModel.documentId}`;

    const request: ChecklistSectionDocumentHttpDeleteRequestModel = {
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        projectId: deleteModel.projectId,
        inspectionTemplateId: deleteModel.inspectionTemplateId,
        sectionId: deleteModel.sectionId,
        documentId: deleteModel.documentId,
        uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistSectionDocument,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistSectionDocumentDeleter =
  new ChecklistSectionDocumentDeleter(addRequest);
